import { z } from "zod";
import { idSchema, languageTagSchema } from "./common.ts";

export const translationStatusSchema = z.enum(["missing", "draft", "needs_review", "approved", "stale"]);

export const requestTranslationSchema = z.object({
  languages: z.array(languageTagSchema).min(1).max(30),
  /** Only translate missing/stale fields (default) or retranslate everything not approved. */
  scope: z.enum(["changed", "all_unapproved"]).default("changed"),
});

export const manualTranslationSchema = z.object({
  language: languageTagSchema,
  entries: z
    .array(
      z.object({
        kind: z.enum(["category", "item", "variant", "modifier_group", "modifier_option"]),
        id: idSchema,
        name: z.string().max(200).nullable().optional(),
        description: z.string().max(2000).nullable().optional(),
        status: z.enum(["draft", "approved", "needs_review"]).default("approved"),
      }),
    )
    .max(500),
});

export const glossarySchema = z.object({
  entries: z
    .array(
      z.object({
        source: z.string().min(1).max(120),
        language: languageTagSchema,
        target: z.string().min(1).max(120),
        /** Keep the source term verbatim (e.g. dish names like "Ćevapi"). */
        keep: z.boolean().optional(),
      }),
    )
    .max(500),
});

export type TranslationJobDto = {
  id: string;
  menuId: string;
  languages: string[];
  status: "queued" | "running" | "completed" | "failed" | "cancelled";
  fieldCount: number;
  creditsCharged: number;
  error: string | null;
  createdAt: string;
  completedAt: string | null;
};

export type TranslationOverviewDto = {
  defaultLanguage: string;
  languages: Array<{
    language: string;
    counts: Record<"missing" | "draft" | "needs_review" | "approved" | "stale", number>;
  }>;
  jobs: TranslationJobDto[];
};
